export const ICDropdown = () => (
  <svg
    width="10"
    height="7"
    viewBox="0 0 10 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.5575 0.942505L5 4.3775L8.4425 0.942505L9.5 2L5 6.5L0.5 2L1.5575 0.942505Z"
      fill="black"
    />
  </svg>
);
